import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
    height: 50px;
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    position: sticky;
    top: 0;
    z-index: 999;
`

export const Wrapper = styled.div`
    height: 100%;
    padding: 0px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const TopLeft = styled.div`
`

export const TopRight = styled.div`
    display: flex;
    align-items: center;
`

export const Logo = styled.span`
    font-weight: bold;
    font-size: var(--fontL);
    cursor: pointer;
`
export const Icons = styled.div`
    position: relative;
    cursor: pointer;
    margin-right: 10px;
`

export const TopIconBadge = styled.span`
    width: 15px;
    height: 15px;
    position: absolute;
    top: -5px;
    right: 0px;
    background-color: var(--secondary);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--fontXS);
    font-weight: bold;
`

export const TopAvatar = styled.img`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
`